import { TableColumnType, TableColumnsType } from 'antd';
import { Wallet } from './types/Wallet';
import { TFunction } from 'i18next';

import { TransactionType } from './components/TransactionType';

import dayjs from 'dayjs';
import { TransactionStatus } from './components/TransactionStatus';
import { DATE_TIME_FORMAT } from '../../constant/dateFormat';

type ColumnTitleProps = {
	title: string;
};

const ColumnTitle = (props: ColumnTitleProps) => {
	return (
		<div className='text-[#000D1D99]  flex items-center cursor-pointer'>
			<span>{props.title}</span>
		</div>
	);
};

export const columns = ({
	isMobile,
	translate,
	onView,
}: {
	isMobile: boolean;
	translate: TFunction;
	onView: (operation: string, transactionNumber: string) => void;
}): TableColumnsType<Wallet> => [
	{
		key: 'transactionNumber',
		dataIndex: 'transactionNumber',
		title: <ColumnTitle title={translate('id')} />,
		render: (value, record) => {
			return (
				<div
					className='cursor-pointer underline text-[#5bcbff] '
					onClick={() => onView(record.operation, record.transactionNumber)}
				>
					{value}
				</div>
			);
		},
		responsive: ['lg'],
	},
	{
		key: 'userName',
		dataIndex: 'userName',
		title: <ColumnTitle title={translate('user')} />,
		render: (value, record) => {
			return <div className='word-break-column  text-lightBlue text-[14px] font-medium'>{value}</div>;
		},
		responsive: ['lg'],
	},
	{
		key: 'walletNumber',
		dataIndex: 'walletNumber',
		title: <ColumnTitle title={translate('walletNumber')} />,
		render: (value, record) => {
			return <div className='cursor-pointer'>{value}</div>;
		},
		responsive: ['lg'],
	},
	{
		key: 'type',
		dataIndex: 'type',
		title: <ColumnTitle title={translate('type')} />,
		render: (value) => <TransactionType type={value} />,
		responsive: ['lg'],
	},
	{
		key: 'amount',
		dataIndex: 'amount',
		title: <ColumnTitle title={translate('amount')} />,
		sorter: (current, next) => Number(current.id) - Number(next.id),
		responsive: ['lg'],
	},
	{
		key: 'createdAt',
		dataIndex: 'createdAt',
		title: <ColumnTitle title={translate('creationDate')} />,
		render: (value) => <div>{dayjs(value).format(DATE_TIME_FORMAT)}</div>,
		responsive: ['lg'],
	},
	{
		key: 'status',
		dataIndex: 'status',
		title: <ColumnTitle title={translate('status')} />,
		render: (value) => <TransactionStatus status={value} />,
		responsive: ['lg'],
	},
	// --- Mobile ---
	...(isMobile
		? [
				{
					key: 'wallet',
					dataIndex: 'wallet',
					render: (_value, record) => (
						<div>
							<ul className='list-none p-0 m-0 flex flex-col gap-2'>
								<li className='flex items-center justify-between'>
									<span>{translate('id')}</span>
									<span
										className='cursor-pointer underline text-[#5bcbff]'
										onClick={() => onView(record.operation, record.transactionNumber)}
									>
										{record?.transactionNumber}
									</span>
								</li>
								<li className='flex items-center justify-between'>
									<span>{translate('user')}</span>
									<span>{record.userName} </span>
								</li>
								<li className='flex items-center justify-between'>
									<span>{translate('type')}</span>
									<TransactionType type={record?.type} />
								</li>
								<li className='flex items-center justify-between'>
									<span>{translate('amount')}</span>
									<span>{record?.amount}</span>
								</li>
								<li className='flex items-center justify-between'>
									<span>{translate('status')}</span>
									<TransactionStatus status={record?.status} />
								</li>
								<li className='flex items-center justify-between'>
									<span>{translate('creationDate')}</span>
									<span>{dayjs(record.createdAt).format(DATE_TIME_FORMAT)}</span>
								</li>
							</ul>
						</div>
					),
				} as TableColumnType<Wallet>,
		  ]
		: []),
];
